import { render, staticRenderFns } from "./SetScoreTableModal.vue?vue&type=template&id=67c86acc&scoped=true&"
import script from "./SetScoreTableModal.vue?vue&type=script&lang=js&"
export * from "./SetScoreTableModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c86acc",
  null
  
)

export default component.exports